export function twoDigitMonth(month?: number) {
  return String(month).length === 1 ? String('0' + month) : String(month);
}
